import React from 'react';
import ForecastHeader from '../components/ForecastHeader';

const Prediction = () => {
    return (
        <div className='block-container-home'
            style={{
                backgroundImage: `url("/assets/images/bg/forecast-bg.png")`,
                backgroundPostion: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover"
            }}
        >
            <ForecastHeader />
        </div>
    );
}

export default Prediction;
